import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { Desktop, Mobile } from '../../../App';
import {
  BV,
  PO,
  UV,
  calculatePercentage,
  formatVP
} from '../../../helpers/helperFunctions';
import { useWindowWide } from '../../../helpers/wideScreen';
import countries from '../../../lib/countries';
import { RANKING } from '../../../routes/routes';
import { CaptionText, P2, P3 } from '../../../styles/FontStyles';
import {
  ArrowPolygon,
  Flexed,
  ProgressBarWithPercentage
} from '../../../styles/GlobalComponents';
import { color, globalImages } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconArrowUnilevel,
  IconUnilevelInfo
} from '../../../styles/Icons';
import { FlexBetween, FlexCenter } from '../../../styles/stylesStyled';
import { ExpandedDiv, LevelExpanded } from '../Volume/VolumePointsStyled';
import { getUnilevel } from '../myTeamBackOffice.actions';
import {
  DashedLine,
  Level,
  Percentage,
  Rank,
  RankHeader,
  RankSubTitle,
  RankTitle,
  RankWrapper,
  Ranks,
  Separator,
  TableData,
  TableHead,
  TableRow,
  UsersList
} from './UnilevelStyled';

const Unilevel = ({ dashboard }) => {
  const { t } = useTranslation('myTeam');
  const { unilevel } = useSelector((state) => state.myTeamBackoffice);
  const [expand, setExpand] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!unilevel) {
      dispatch(getUnilevel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const wide = useWindowWide(800);

  return (
    <div>
      <RankWrapper>
        <Ranks
          style={{
            marginBottom:
              unilevel?.currentPackageRank?.packageRankId === 20 && 0
          }}>
          <Rank>
            <img
              src={globalImages.logoOnlyLetter}
              alt='logo'
              style={{ marginRight: wide ? 20 : 5, width: wide ? 70 : 40 }}
            />
            <RankHeader>
              <RankTitle> {t('unilevel_page.current_rank')}</RankTitle>
              <RankSubTitle>{unilevel?.currentPackageRank?.name}</RankSubTitle>
            </RankHeader>
          </Rank>

          {unilevel?.currentPackageRank?.packageRankId !== 20 && (
            <>
              <Separator>
                <DashedLine></DashedLine>
              </Separator>

              <Icon mr='20' mrSM='0'>
                <IconArrowUnilevel />
              </Icon>

              <Rank>
                <img
                  src={globalImages.logoOnlyLetter}
                  alt='logo'
                  style={{ marginRight: wide ? 20 : 5, width: wide ? 70 : 40 }}
                />
                <RankHeader>
                  <RankTitle>{t('unilevel_page.next_rank')}</RankTitle>
                  <RankSubTitle>{unilevel?.nextPackageRank?.name}</RankSubTitle>
                </RankHeader>
              </Rank>
            </>
          )}
        </Ranks>

        {!unilevel?.currentPackageRank && (
          <Link to={RANKING}>
            <P2 center mt='20' color={color.colors.primary900}>
              {t('unilevel_page.check_ranking')}
            </P2>
          </Link>
        )}

        {unilevel?.currentPackageRank !== null &&
          unilevel?.currentPackageRank?.name !== 'Customer' &&
          unilevel?.currentPackageRank?.name !== 'Partner' &&
          unilevel?.currentPackageRank?.packageRankId !== 20 && (
            <Flexed column mt='30'>
              <CaptionText mb='4' color={color.colors.neutral500} caps>
                {t('unilevel_page.complete_for_the_next_rank')}
              </CaptionText>
              <FlexCenter>
                <P3 color={color.colors.neutral700} mb='10' semiBold>
                  {t('unilevel_page.weak_team')}
                </P3>
                <Icon
                  ml='10'
                  mb='11'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {}}
                  data-tip
                  data-for={'paidTeam'}>
                  <IconUnilevelInfo />
                </Icon>
                <ReactTooltip
                  id={'paidTeam'}
                  place='top'
                  effect='solid'
                  backgroundColor='#fff'
                  textColor={color.colors.neutral900}>
                  <div style={{ width: 200 }}>
                    {t('unilevel_page.paid_team_tip')}
                  </div>
                </ReactTooltip>
              </FlexCenter>

              <Flexed center between mb='7'>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.current')}:{' '}
                  {formatVP(
                    unilevel?.nextPackageRank?.paidTeamCurrent
                      ? unilevel?.nextPackageRank?.paidTeamCurrent
                      : 0
                  )}{' '}
                  {BV}
                </CaptionText>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.required')}:{' '}
                  {formatVP(unilevel?.nextPackageRank?.paidTeamLimit)} {BV}
                </CaptionText>
              </Flexed>
              <ProgressBarWithPercentage
                percentage={calculatePercentage(
                  unilevel?.nextPackageRank?.paidTeamCurrent,
                  unilevel?.nextPackageRank?.paidTeamLimit
                )}
                color={
                  calculatePercentage(
                    unilevel?.nextPackageRank?.paidTeamCurrent,
                    unilevel?.nextPackageRank?.paidTeamLimit
                  ) > 99
                    ? color.colors.success500
                    : color.colors.warning
                }>
                <div>
                  <div>
                    {calculatePercentage(
                      unilevel?.nextPackageRank?.paidTeamCurrent,
                      unilevel?.nextPackageRank?.paidTeamLimit
                    )}
                    %
                  </div>
                </div>
              </ProgressBarWithPercentage>

              <FlexCenter>
                <P3 color={color.colors.neutral700} mb='10' semiBold>
                  40 / 40 / 20 Unilevel
                </P3>
                <Icon
                  ml='10'
                  mb='11'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {}}
                  data-tip
                  data-for={'directVolume'}>
                  <IconUnilevelInfo />
                </Icon>
                <ReactTooltip
                  id={'directVolume'}
                  place='top'
                  effect='solid'
                  backgroundColor='#fff'
                  textColor={color.colors.neutral900}>
                  <div style={{ width: 200 }}>
                    {t('unilevel_page.direct_volume_tip')}
                  </div>
                </ReactTooltip>
              </FlexCenter>

              <Flexed center between mb='7'>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.current')}:{' '}
                  {formatVP(
                    unilevel?.nextPackageRank?.directVolumeCurrent
                      ? unilevel?.nextPackageRank?.directVolumeCurrent
                      : 0
                  )}{' '}
                  {UV}
                </CaptionText>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.required')}:{' '}
                  {formatVP(unilevel?.nextPackageRank?.directVolumeLimit)} {UV}
                </CaptionText>
              </Flexed>

              <ProgressBarWithPercentage
                percentage={calculatePercentage(
                  unilevel?.nextPackageRank?.directVolumeCurrent,
                  unilevel?.nextPackageRank?.directVolumeLimit
                )}
                color={
                  calculatePercentage(
                    unilevel?.nextPackageRank?.directVolumeCurrent,
                    unilevel?.nextPackageRank?.directVolumeLimit
                  ) > 99
                    ? color.colors.success500
                    : color.colors.warning
                }>
                <div>
                  <div>
                    {calculatePercentage(
                      unilevel?.nextPackageRank?.directVolumeCurrent,
                      unilevel?.nextPackageRank?.directVolumeLimit
                    )}
                    %
                  </div>
                </div>
              </ProgressBarWithPercentage>

              <FlexCenter>
                <P3 color={color.colors.neutral700} mb='10' semiBold>
                  20% {t('unilevel_page.in_strong_team')}
                </P3>
                <Icon
                  ml='10'
                  mb='11'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {}}
                  data-tip
                  data-for={'strongTeam'}>
                  <IconUnilevelInfo />
                </Icon>
                <ReactTooltip
                  id={'strongTeam'}
                  place='top'
                  effect='solid'
                  backgroundColor='#fff'
                  textColor={color.colors.neutral900}>
                  <div style={{ width: 200 }}>
                    {t('unilevel_page.in_strong_team_tip')}
                  </div>
                </ReactTooltip>
              </FlexCenter>

              <Flexed center between mb='7'>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.current')}:{' '}
                  {formatVP(
                    unilevel?.nextPackageRank?.strongTeamCurrent
                      ? unilevel?.nextPackageRank?.strongTeamCurrent
                      : 0
                  )}{' '}
                  {UV}
                </CaptionText>
                <CaptionText color={color.colors.neutral700}>
                  {t('unilevel_page.required')}:{' '}
                  {formatVP(unilevel?.nextPackageRank?.strongTeamLimit)}
                  {UV}
                </CaptionText>
              </Flexed>

              <ProgressBarWithPercentage
                percentage={calculatePercentage(
                  unilevel?.nextPackageRank?.strongTeamCurrent,
                  unilevel?.nextPackageRank?.strongTeamLimit
                )}
                color={
                  calculatePercentage(
                    unilevel?.nextPackageRank?.strongTeamCurrent,
                    unilevel?.nextPackageRank?.strongTeamLimit
                  ) > 99
                    ? color.colors.success500
                    : color.colors.warning
                }>
                <div>
                  <div>
                    {calculatePercentage(
                      unilevel?.nextPackageRank?.strongTeamCurrent,
                      unilevel?.nextPackageRank?.strongTeamLimit
                    )}
                    %
                  </div>
                </div>
              </ProgressBarWithPercentage>
            </Flexed>
          )}
      </RankWrapper>
      {!dashboard && (
        <>
          <Desktop>
            <UsersList>
              {unilevel?.directTeamUsers?.length > 0 && (
                <>
                  <TableRow>
                    <TableHead style={{ width: '8%' }}></TableHead>
                    <TableHead style={{ width: '15.3%' }}>
                      {' '}
                      {t('unilevel_page.user_id')}
                    </TableHead>
                    <TableHead style={{ width: '25%' }}>
                      {' '}
                      {t('unilevel_page.user')}
                    </TableHead>
                    <TableHead style={{ width: '15.3%' }}>
                      {' '}
                      {t('unilevel_page.direct_volume')}
                    </TableHead>
                    <TableHead style={{ width: '15.3%' }}>
                      {t('unilevel_page.effective_volume')}
                    </TableHead>
                    <TableHead style={{ width: '15.3%' }}>
                      {' '}
                      {t('unilevel_page.percentage')}
                    </TableHead>
                    <TableHead style={{ width: '5.6%', textAlign: 'right' }}>
                      {t('unilevel_page.team_side')}
                    </TableHead>
                  </TableRow>

                  {unilevel?.directTeamUsers?.map((member, i) => (
                    <TableRow key={i}>
                      <TableData style={{ width: '8%' }}>
                        <b>{`${i + 1}.`}</b>
                      </TableData>
                      <TableData style={{ width: '15.3%' }}>
                        {member.id}
                      </TableData>
                      <TableData
                        style={{
                          width: '25%',
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                        {countries.map(
                          (country, i) =>
                            country.code === member.countryCode && (
                              <img
                                key={i}
                                src={country.flag}
                                alt='flag'
                                style={{
                                  width: '28px',
                                  height: '20px',
                                  marginRight: '5px'
                                }}
                              />
                            )
                        )}{' '}
                        {member.username}
                      </TableData>
                      <TableData style={{ width: '15.3%' }}>
                        {formatVP(member.totalVolume)} {UV}
                      </TableData>
                      <TableData style={{ width: '15.3%' }}>
                        {formatVP(
                          member.effectiveVolume ? member.effectiveVolume : 0
                        )}{' '}
                        {UV}
                      </TableData>
                      <TableData style={{ width: '15.3%' }}>
                        <Percentage percentage={member.percentage > 100}>
                          {`${member.percentage ? member.percentage : 0} %`}
                        </Percentage>
                      </TableData>

                      <TableData style={{ width: '5.6%', textAlign: 'right' }}>
                        {member.leg === 0
                          ? t('unilevel_page.left')
                          : t('unilevel_page.right')}
                      </TableData>
                    </TableRow>
                  ))}
                </>
              )}
            </UsersList>
          </Desktop>

          <Mobile>
            {unilevel?.directTeamUsers?.length > 0 && (
              <TableHead style={{ marginBottom: 16 }}>unilevel board</TableHead>
            )}
            {unilevel?.directTeamUsers?.length > 0 &&
              unilevel?.directTeamUsers?.map((member, i) => (
                <div key={i}>
                  <Level
                    onClick={() =>
                      setExpand(expand === member.id ? '' : member.id)
                    }
                    expand={expand === member.id}>
                    <FlexBetween style={{ width: 'calc(100% - 30px )' }}>
                      <FlexCenter>
                        <TableData style={{ marginRight: 10 }}>
                          <b>{`${i + 1}.`}</b>
                        </TableData>
                        <TableData
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                          {countries.map(
                            (country, i) =>
                              country.code === member.countryCode && (
                                <img
                                  key={i}
                                  src={country.flag}
                                  alt='flag'
                                  style={{
                                    width: '28px',
                                    height: '20px',
                                    marginRight: '5px'
                                  }}
                                />
                              )
                          )}{' '}
                          {member.username}
                        </TableData>
                      </FlexCenter>

                      <Percentage percentage={member.percentage > 100}>
                        {`${member.percentage ? member.percentage : 0} %`}
                      </Percentage>
                    </FlexBetween>

                    <ArrowPolygon
                      customColor={color.colors.neutral900}
                      direction={
                        expand === member.id
                          ? t('generations_page.down')
                          : t('generations_page.right')
                      }
                    />
                  </Level>
                  <LevelExpanded
                    expand={expand === member.id}
                    style={{
                      background: 'none',
                      maxHeight: expand === member.id ? 500 : 0
                    }}>
                    <ExpandedDiv>
                      <div>
                        <div style={{ textAlign: 'left', marginBottom: 12 }}>
                          <TableHead style={{ marginBottom: 5 }}>
                            {' '}
                            {t('unilevel_page.direct_volume')}
                          </TableHead>
                          <TableData>
                            {formatVP(member.totalVolume)} {UV}
                          </TableData>
                        </div>
                        <div style={{ textAlign: 'left', marginBottom: 12 }}>
                          <TableHead style={{ marginBottom: 5 }}>
                            {t('unilevel_page.effective_volume')}
                          </TableHead>
                          {formatVP(
                            member.effectiveVolume ? member.effectiveVolume : 0
                          )}{' '}
                          {UV}
                        </div>
                        <div style={{ textAlign: 'left', marginBottom: 12 }}>
                          <TableHead style={{ marginBottom: 5 }}>
                            {t('unilevel_page.team_side')}
                          </TableHead>
                          <TableData
                            style={{ width: '5.6%', textAlign: 'right' }}>
                            {member.leg === 0 ? 'Left' : 'Right'}
                          </TableData>
                        </div>
                      </div>
                    </ExpandedDiv>
                  </LevelExpanded>
                </div>
              ))}
          </Mobile>
        </>
      )}
    </div>
  );
};

export default Unilevel;
